<template>
    <b-badge v-if="statusInfo" :variant="statusInfo.variant">
        {{ statusInfo.text }}
    </b-badge>
    <span v-else>-</span>
</template>

<script>
import { BBadge } from "bootstrap-vue";

export default {
    components: {
        BBadge,
    },
    props: {
        row: Object,
        field: {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        return {
            statusMap: {
                0: { text: "Ödeme Bekleniyor", variant: "light-warning" },
                1: { text: "Ödendi", variant: "light-success" },
                2: { text: "Pasif", variant: "light-secondary" },
                3: { text: "Onay Sürecinde", variant: "light-info" },
            },
        };
    },
    computed: {
        statusInfo() {
            return this.field != null ? this.statusMap[this.field] : null;
        },
    },
};
</script>
